import { createRoute } from '@tanstack/react-router'
import { ProfileDetailsPage } from '@/features/profiles/pages/ProfileDetailsPage'
import { Route as profilesRoute } from '../profiles'

export const Route = createRoute({
  getParentRoute: () => profilesRoute,
  path: '/$id',
  component: ProfileDetailsPage,
})
